import productItemWhishlist from "./productItemWhishlist"
export default productItemWhishlist;
